{
  "errorCode": "404",
  "errorMessage": "Stranica nije pronađena",
  "goToDashboard": "Idi na nadzornu ploču"
}
